<script lang="ts" setup>
import { useAppStore } from "@/store/app.store";
import { useI18n } from "vue-i18n";
import { computed } from "vue";
import DispatcherPermissionCard from "@/views/dispatchers/components/DispatcherPermissionCard.vue";
import type { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto";

const appStore = useAppStore();
const { t } = useI18n();

const model = defineModel<DispatcherPermissionValue[]>({ default: [] });

const allPermissions = computed(() => {
  return appStore.dispatcher?.allExistingPermissions || [];
});
</script>

<template>
  <div>
    <div class="font-weight-medium font-size-16">
      {{ t("general.permissions") }}
    </div>

    <v-row class="mt-3">
      <v-col v-for="item in allPermissions" :key="item.group" cols="3">
        <dispatcher-permission-card v-model="model" :permission-group="item" />
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped></style>
